module.exports = __webpack_public_path__ + "static/media/public-black-18dp.53ea75f9.svg";